import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const ClipImage = ({ src, alt, className = "", testId }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <div ref={ref} data-testid={testId} className={`notch relative overflow-hidden bg-ink-2 ${className}`}>
      <motion.img src={src} alt={alt} loading="lazy" style={{ y }} className="absolute inset-x-0 -top-[10%] h-[120%] w-full object-cover" />
      <div aria-hidden className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent" />
    </div>
  );
};
